import * as util from '../utils/util';
import {getObjectHasProperty} from "../utils/util";
import {getDatasWithOption} from "../utils/service";

(function ($, global) {
	"use strict";
	nc.lineage.cartoonSeries = function (options) {
		if (!options) return;
		var option = $.extend({
			wrap: null,
			data: null,
            apiPath: '',
			device: '' || 'mobile',
			category: null,
			global: global || window
		}, options);
        var _categoryIndex;

		init();

		function init() {
			// render by data, condition
			// setInstance(option.data);
            console.log('# cartoon-series.js  init');

            getDatasWithOption([{
                type: 'GET',
                url: option.apiPath +'/conti/getContent?service=lineage&alias=cartoon-series&lang=ko-KR',
                dataType: 'json',
                contentType: 'application/json',
                Accept: 'application/json'
            }], (data) => {
                console.log('cartoon-series.js data : ', JSON.parse(data.jsonData) );
                if(data.jsonData.length <= 0) {
                    setNoData();
                } else {
                    setInstance(JSON.parse(data.jsonData));
                }
            }, (data) => {
                console.log('데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.');
            });

		}
		function setNoData() {
            $(option.wrap[0]).empty().append(`<div class="nodata"> - </div>`);
        }

		function setInstance(data) {
			let _data, _currentData = {};
			_data = data;

			let LIVE_boardCategoryMap = [{"에피소드0 시즌2":"5ec50d7c82915c0001ace18c"},{"에피소드0 시즌1":"5ec50d7c82915c0001ace18d"},{"린 글리쉬":"5ec50d7c82915c0001ace18e"},{"축데이":"5ec50d7c82915c0001ace18f"},{"아덴 훌쩍 여행":"5ec50d7c82915c0001ace190"},{"로드 오브 리니지":"5ec50d7c82915c0001ace191"},{"리니지 다반사":"5ec50d7c82915c0001ace192"},{"새트의 아덴 탐험기":"5ec50d7c82915c0001ace193"},{"신들의 이야기":"5ec50d7c82915c0001ace194"},{"인간의 이야기":"5ec50d7c82915c0001ace195"},{"오만의 탑":"5ec50d7c82915c0001ace196"}];
			let getBoardCategoryMap = (window._serviceEnv  == 'LIVE' ) ? window._boardCategoryMap : LIVE_boardCategoryMap;

			let getInitCategory = getObjectHasProperty(getBoardCategoryMap , "축데이");
			let initCategory = option.category || getInitCategory;

			console.log( '# board-series.js setInstance() initCategory : ', initCategory );

			$.each( data.items , function(i){
				if( this.category == initCategory){
					_currentData = this;
					_currentData.index = i;
				}
			});

			_data.current = initCategory;
			_categoryIndex = _currentData.index;
			_data.currentTitle = _currentData.title;
			_data.currentSeries = _currentData.series;

			console.log( 'setInstance : initCategory, _data.current  ' , initCategory, _data.current );


            let tmpl_innerlist = data.items.map( (item, i) => {
                return `
                <li data-category="${item.category}"><a ${(item.category == initCategory) ? `class="on"`: `` } data-category="${item.category}" href="list?categoryId=${item.category}"><img src="${item.thumbnail}" /><span class="category">${item.title}</span><strong class="flag ${item.series}"></strong></a></li>
            `;
            }).join('');

            let tmpl_list = `
            <div class="ui-dropdown ui-dropdown-cartoon">
                <div class="select"><strong class="flag ${_currentData.series}"></strong><span class="category">${_currentData.title}</span></div>
                <ul class="option" id="rollCartoonCategory">
                ${tmpl_innerlist}
                </ul>
            </div>
            `;
            let tmpl_intro = `
            <div class="thumb" style="background-image:url('${_currentData.introImg}')"></div>
            <div class="detail">
                <div class="title">${_currentData.title}</div>
                <div class="info"><span class="writer">${_currentData.writer}</span><span class="date">${_currentData.date}</span></div>
                <div class="desc">${_currentData.desc}</div>
                <div class="util">
                    <a class="btn-view-latest" href="${_currentData.latestUrl}">최근 회 보기</a>
                    <a class="btn-view-first" href="${_currentData.firstUrl}">첫 회 보기</a>
                    ${(option.device !== 'ingame') ? '<div id="share" class="share"><button class="btn-share">공유</button></div>' : '' }
                </div>
            </div>
            `;

			$(option.wrap[0]).append( tmpl_list );
			$(option.wrap[1]).append( tmpl_intro );

            if(option.device !== 'ingame') {
                var share = new window.ncui.share({
                    snsOrder: ['facebook', 'copy', 'twitter'],
                    title: '글을 SNS에 공유해보세요.',
                    dimmed: true,
                    useNavigatorShare: true,
                    shareUrl: window.location.href,
                    btnShareTrigger: {
                        selector: '.btn-share',
                        staticDistanceFromBtnToLayer: [-200, 20]
                    }
                });
            }

			if (option.device === 'pc' || option.device === 'launcher' || option.device === 'ingame' ) {
                /* 여기부터 */
                responsiveObj.slidesToScroll = 1;

                $('#rollCartoonCategory').slick({
                    dots: true,
                    arrows: true,
                    infinite: false,
                    slidesToShow: responsiveObj['default'].slidesToShow,
                    slidesToScroll: responsiveObj.slidesToScroll,
                    // initialSlide: _categoryIndex,
                    responsive: [
                        {
                            breakpoint: responsiveObj['max'].breakpoint,
                            settings: {
                                slidesToShow: responsiveObj['max'].slidesToShow
                            }
                        },
                        {
                            breakpoint: responsiveObj['pc'].breakpoint,
                            settings: {
                                slidesToShow: responsiveObj['pc'].slidesToShow
                            }
                        },
                        {
                            breakpoint: responsiveObj['tablet'].breakpoint,
                            settings: {
                                slidesToShow: responsiveObj['tablet'].slidesToShow
                            }
                        }
                    ]
                });

                getslidesToShow(_categoryIndex);
                $(window).resize(function() {
                    $('#rollCartoonCategory').slick('setPosition');
                    getslidesToShow(_categoryIndex);
                });

                /*$(window).resize(function() {
                    $('#rollCartoonCategory').slick('setPosition');
                    let current = $('#rollCartoonCategory').slick('slickCurrentSlide');
                    $('#rollCartoonCategory').slick('slickGoTo', current );
                });*/

			} else {
			    // mobile device

                var dropdownIndex = 0;
                var dropdown = nc.lineage.dropdown({
                    wrap: $('.ui-dropdown-cartoon'),
                    activateIndex: dropdownIndex,
                    activateCallback: function (obj) {
                        location.href= $(obj.btn).find("a").attr("href");
                    }
                });

			}
		}
		function showLoadingBar(flag) {
			if (flag) {
				$('.loading-bar').show();
			} else {
				$('.loading-bar').hide();
			}
		}
	};

    var responsiveObj = {
        'default': {
            breakpoint: 1920,
            slidesToShow : 7
        },
        'max': {
            breakpoint: 1260,
            slidesToShow : 5
        },
        'pc': {
            breakpoint: 960,
            slidesToShow: 3
        },
        'tablet': {
            breakpoint: 640,
            slidesToShow: 1
        }
    };
    var _categorySlideIndex;
    function getslidesToShow(_categoryIndex){
        if ( responsiveObj['max'].breakpoint < window.innerWidth  )  {
            _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['default'].slidesToShow + 1);
        } else if ( responsiveObj['pc'].breakpoint < window.innerWidth && window.innerWidth <= responsiveObj['max'].breakpoint ) {
            if(_categoryIndex == 7) {
                _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['max'].slidesToShow + 1);
            } else if (_categoryIndex == 6){
                _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['max'].slidesToShow + 2);
            } else {
                _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['max'].slidesToShow + 3);
            }
        } else if ( responsiveObj['tablet'].breakpoint < window.innerWidth && window.innerWidth <= responsiveObj['pc'].breakpoint ) {
            if(_categoryIndex >= 7) {
                _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['pc'].slidesToShow + 1);
            }else {
                _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['pc'].slidesToShow + 2);
            }
        } else {
            _categorySlideIndex = Math.max(0, _categoryIndex - responsiveObj['tablet'].slidesToShow + 1);
        }
        $('#rollCartoonCategory').slick('slickGoTo', _categorySlideIndex );
    }




}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/board/cartoon-series.js